



































import Vue, { PropOptions } from 'vue';

export type FaqItem = Blok & {
  title: string;
  text: string;
};

export default Vue.extend({
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<FaqItem>,
  },
  data() {
    return {
      isOpen: false,
    };
  },
});
